import { CSSInterpolation } from '@emotion/css/create-instance';
import { css } from '@emotion/react';
import { FoundationIcon, Icon24, Type } from '@robinhood/design';

interface PropsIface {
  icon: Icon24;
  text: string;
  overrideRootStyles?: CSSInterpolation;
}

const ValuePropColumn = ({ icon, text, overrideRootStyles }: PropsIface) => {
  return (
    <div css={[root, overrideRootStyles]}>
      <FoundationIcon type={icon} />
      <Type.Text size='S'>{text}</Type.Text>
    </div>
  );
};

const root = css`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  text-align: center;
  flex: 1;
`;

export default ValuePropColumn;
